import React, {Component} from 'react';
import {Button, Col, InputGroup, Label, Row} from "reactstrap";
import CalendarioPicker from "../../../comum/components/Calendario";
import {observer} from "mobx-react";
import Card from '../../../comum/components/Card';


@observer
export class FiltrosSailingBreakdown extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    filtrar(){
        this.controller.pesquisar()
    }

    render() {
        return (
            <Card>
                <div className="filtros">

                    <Row className="align-items-end">

                        <Col xl={3} md={4} sm={6} xs={12} className="mb-1">
                            <div className="w-100">
                                <Col xs={12} className="col-label px-0">
                                    <Label>Período</Label>
                                </Col>

                                <Col xs={12} className="px-0">
                                    <InputGroup className={this.controller.seletorPeriodo ? 'ativo' : ''}>
                                        <CalendarioPicker visivel={this.controller.seletorPeriodo}
                                                            onChangeInicio={(valor) => this.controller.setDataInicioTemp(valor)}
                                                            onChangeFim={(valor) => this.controller.setDataFimTemp(valor)}
                                                            dataInicial={this.controller.dataInicial}
                                                            dataFinal={this.controller.dataFinal}
                                                            fechar={() => this.controller.alternarDataSeletor()}
                                                            filtrar={(valor) => this.controller.alterarPeriodo(valor)}/> 
                                    </InputGroup>

                                </Col>
                            </div>
                        </Col>

                        <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom">
                            <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.filtrar()}>Filtrar</Button>
                        </Col>

                    </Row>
                </div>
            </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/sailing-breakdown/components/FiltrosSailingBreakdown.js